import { schemas } from '#oaf_schema.registry';
import { selectJapanesePublisher } from '../stores/publisher/publisherStore';
export function hasJapaneseCompanyDetails(publisher) {
  var _jpPublisher$plugins$;
  if (!publisher) {
    return false;
  }
  const jpPublisher = selectJapanesePublisher({
    publisher
  });
  if (!jpPublisher) {
    return false;
  }

  // Show notification when required fields are missing
  if (!schemas['publisher/localizations/jp'].get().required.every(key => !!jpPublisher[key])) {
    return false;
  }
  const logo = (_jpPublisher$plugins$ = jpPublisher.plugins.find(plugin => plugin.pluginType === 'publisher/plugins/PublisherLogo')) === null || _jpPublisher$plugins$ === void 0 ? void 0 : _jpPublisher$plugins$.data;
  if (!logo || logo.items.length === 0 || !logo.items[0].mediaId) {
    return false;
  }

  // Note [AppExchange_Japanese]:
  // Uncomment the block of code below to show notification when non-required fields are missing
  /*
   if (!jpPublisher.description) {
      return false;
  }
  if (!jpPublisher.website) {
      return false;
  }
  if (!jpPublisher.email) {
      return false;
  }
  if (!jpPublisher.phoneNumber) {
      return false;
  }
  if (!jpPublisher.hQLocation) {
      return false;
  }
  */

  return true;
}
export function hasAnyJapaneseCompanyDetails(publisherJp) {
  var _publisherJp$plugins$, _logo$items, _logo$items$;
  if (!publisherJp) {
    return false;
  }
  if (Object.keys(schemas['publisher/localizations/jp'].get().properties).filter(test => test !== 'external_id' && test !== 'plugins').some(key => !!publisherJp[key])) {
    return true;
  }
  const logo = (_publisherJp$plugins$ = publisherJp.plugins.find(plugin => plugin.pluginType === 'publisher/plugins/PublisherLogo')) === null || _publisherJp$plugins$ === void 0 ? void 0 : _publisherJp$plugins$.data;
  if (logo !== null && logo !== void 0 && (_logo$items = logo.items) !== null && _logo$items !== void 0 && (_logo$items$ = _logo$items[0]) !== null && _logo$items$ !== void 0 && _logo$items$.mediaId) {
    return true;
  }
  return false;
}